import React, { useState } from 'react';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { Button } from '@mui/material';
import { ConfirmationModal } from '../../components/ConfirmationModal';
import LoadMealBalanceByAccountNo from './LoadMealBalanceByAccountNo';
import { usePermission } from '../../hooks/usePermission';

type UploadByAccountNoButtonProps = {
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    renderButton?: boolean;
};

const UploadByAccountNoButton = ({ open: controlledOpen, onOpenChange, renderButton = true }: UploadByAccountNoButtonProps = {}) => {
    const [internalOpen, setInternalOpen] = useState(false);
    const isControlled = controlledOpen !== undefined;
    const open = isControlled ? controlledOpen : internalOpen;
    const setOpen = (v: boolean) => (isControlled ? onOpenChange?.(v) : setInternalOpen(v));
    const { hasPermission: canUploadByAccountNo, isLoading: isUploadByAccountNoPermissionLoading } = usePermission({
        code: 'Corporate.POST.Writing.YemekKartınaHesapNumarasıİleBakiyeYükleme',
    });

    if (isUploadByAccountNoPermissionLoading || !canUploadByAccountNo) {
        return null;
    }

    return (
        <>
            {renderButton && (
            <Button
                variant="outlined"
                startIcon={<AccountBalanceIcon />}
                onClick={() => setOpen(true)}
                sx={{
                    border: '1px solid',
                    borderColor: '#22c55e',
                    color: '#16a34a',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                    textTransform: 'none',
                    borderRadius: 2,
                    px: 3,
                    py: 1.2,
                    background: 'white',
                    boxShadow: '0 4px 12px rgba(34, 197, 94, 0.10)',
                    flexShrink: 0,
                    '&:hover': {
                        background: 'rgba(34,197,94,0.08)',
                        border: '1px solid',
                        borderColor: '#22c55e',
                        transform: 'translateY(-1px)'
                    },
                    transition: 'all 0.3s ease',
                    minWidth: 180,
                }}
            >
                Hesap No ile Bakiye Yükle
            </Button>
            )}
            <ConfirmationModal
                isOpen={open}
                onClose={() => setOpen(false)}
                onConfirm={() => { }} // Boş fonksiyon, çünkü LoadMealBalanceByAccountNo kendi confirm'ini yönetiyor
                title="Hesap No ile Toplu Bakiye Yükle"
                isLoading={false}
                confirmButtonText="" // Boş string ile buton gizle
                closeButtonText="" // Boş string ile buton gizle
                optionalWidth="1200px"
                customHeaderStyle={{
                    background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
                    titleColor: 'white',
                }}
            >
                <LoadMealBalanceByAccountNo onClose={() => setOpen(false)} />
            </ConfirmationModal>
        </>
    );
};

export default UploadByAccountNoButton;
